import { Status } from '../../http';

export class AuthResponseData {
  constructor(
    public status: Status,
    public value?: object | string,
    public error?: string
  ) {}
}
